import React from 'react';
import { Inspector } from '@bynder/design-system';
import BackgroundElement from 'packages/pages/design/components/BackgroundElement';

type Props = {
    id: number;
    isLast: boolean;
    isDisabled: boolean;
};

const ShotItemGlobal = ({ id, isDisabled, isLast = true }: Props) => (
    <BackgroundElement elementId={id} isDisabled={isDisabled}>
        {isLast ? <Inspector.Divider /> : null}
    </BackgroundElement>
);

export default ShotItemGlobal;
